import React from 'react';
import { Slide } from 'react-reveal';
import CookingBackground from '../../images/background_cooking_icons.png'
import PropTypes from 'prop-types'
import style from './style.module.scss'

const PageHeader = ({ height, subheader, headercenter, image, background, color = '', fontFamily, fontSize, backgroundImage, backgroundSize }) => {
    return (
        <div
            className={style.pageHeaderWrapper}
            style={{
                background: background && `${background}`,
                color: color && `${color}`,
                fontFamily: fontFamily && `${fontFamily}`,
                backgroundImage: backgroundImage ? `url(${backgroundImage})` : `url(${CookingBackground})`,
                backgroundSize: backgroundSize ? `${backgroundSize}` : 'contain'
            }}>
            {
                headercenter &&
                <Slide left>
                    <h2 id="middle" className={`${style.headerMiddle}`} style={{ color: color }}>
                        {headercenter}
                    </h2>
                </Slide>
            }
            {
                subheader &&
                <Slide right>
                    <h2 id="subheader" className={`${style.subHeader}`} style={{ color: color }}>
                        {subheader}
                    </h2>
                </Slide>
            }
        </div>
    )
}

PageHeader.propTypes = {
    height: PropTypes.number,
    header: PropTypes.string,
    headercenter: PropTypes.string,
    backgroundSize: PropTypes.string,
    background: PropTypes.string,
    color: PropTypes.string,
    fontFamily: PropTypes.string,
    fontSize: PropTypes.number,
    image: PropTypes.bool
}

PageHeader.defaultProps = {
    height: null,
    header: null,
    headercenter: null,
    background: null,
    color: null,
    fontFamily: null,
    fontSize: null,
    image: false,
    backgroundSize: 'contain'
}

export default PageHeader